import { TaskView } from '@seen/core/models/taskView'
import { IconCheck } from '@tabler/icons-react'
import type { JSX } from 'react'
import { IconView } from '#src/components/icons/IconView.tsx'
import { RichText } from '#src/components/RichText.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ViewOption({
  view: viewReferenceString,
  isSelected,
}: {
  view: string
  isSelected?: boolean
}): JSX.Element {
  const { data: view } = useRead(TaskView, viewReferenceString)
  return (
    <div className="flex flex-1 items-center justify-between">
      <div className="flex items-center gap-2">
        <IconView className="text-foreground-tertiary" />
        <RichText value={view?.name ?? ''} className="line-clamp-1" />
      </div>
      {isSelected && <IconCheck className="mr-0.5 size-4 shrink-0" />}
    </div>
  )
}
